import styled from 'styled-components';

// ZEST-692 (PM tweak): compact the time-entry form's vertical rhythm so the
// enlarged, resizable Description field fits without pushing the modal footer
// off-screen.
// eslint-disable-next-line import/prefer-default-export
export const SCompactForm = styled.div`
  .ant-form-item {
    margin-bottom: 12px;
  }
`;
